// @flow
import type { UpdateEntryDateAction } from "../types";

/**
 * Update the entry date being used in the modelcatalog
 */
export const updateEntryDate = (
  entryDate: ISO_DATE,
): UpdateEntryDateAction => ({
  type: "UPDATE_ENTRYDATE",
  payload: entryDate,
});
